import type { NutritionValues } from '@/types/api';

interface NutritionSummaryProps {
  nutrition: NutritionValues;
  title?: string;
  className?: string;
}

function formatKcal(value: number): string {
  return `${Math.round(value)} kcal`;
}

function formatGram(value: number): string {
  return `${Math.round(value * 10) / 10} g`;
}

/**
 * Compact nutrition summary: kcal + macros.
 */
export function NutritionSummary({
  nutrition,
  title,
  className = '',
}: NutritionSummaryProps) {
  return (
    <div className={className}>
      {title && (
        <p className="text-xs font-medium text-gray-500 mb-1">{title}</p>
      )}
      <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
        <span className="font-semibold text-gray-900">
          {formatKcal(nutrition.energyKcal)}
        </span>
        <span className="text-gray-600">
          P {formatGram(nutrition.proteins)}
        </span>
        <span className="text-gray-600">
          G {formatGram(nutrition.carbohydrates)}
        </span>
        <span className="text-gray-600">L {formatGram(nutrition.fat)}</span>
        <span className="text-gray-400">
          F {formatGram(nutrition.fiber)}
        </span>
      </div>
    </div>
  );
}
